import type { ReactNode } from 'react';
import type { RemixiconComponentType } from '@remixicon/react';

export interface IconLabelProps {
  /** The glyph, taken from `waadooIcons` (components/ui/icons/waadooIcons.ts). */
  icon: RemixiconComponentType;
  children: ReactNode;
}

/**
 * A small monochrome icon before its words: a title, a tab, a label. The
 * icon is decorative — the words say the same — and drawn in the secondary
 * text tone so that it marks the line without competing with it. Laid out by
 * `.waadoo-icon-label` in styles.css.
 */
export function IconLabel(props: IconLabelProps) {
  const { icon: Icon, children } = props;
  return (
    <span className="waadoo-icon-label">
      <Icon className="waadoo-icon-label__icon" aria-hidden focusable="false" />
      {children}
    </span>
  );
}
